import React, { Component } from "react";


class ParticipantsList extends Component {
  
  constructor(props) 
	{
		super(props);
		this.state = 
			{
				sessionUsers: JSON.parse(localStorage.getItem('tempUsers'))
			}
		window['updateSessionUsersList'] = this.updateSessionUsersList;
		window['setStatusOnList'] = this.setStatusOnList;
	}
 
	componentDidMount(){
		
		var sessionUsersNum = 0;
		if (this.state.sessionUsers.length > 0 )
			{
				sessionUsersNum = this.state.sessionUsers.length - 1;
			}
		
		this.props.updateStateFromChild({signedUpUsers: sessionUsersNum});
	}
	
	updateSessionUsersList=()=>{
		let membersArray = [];
		if ( JSON.parse(localStorage.getItem('tempUsers')) )
			{
				membersArray = JSON.parse(localStorage.getItem('tempUsers'));
			}
			
		this.setState({
			sessionUsers: membersArray
			}, ()=>{
				var sessionUsersNum = this.state.sessionUsers.length - 1; 
				this.props.updateStateFromChild({signedUpUsers: sessionUsersNum});
			});	
	}
	
	setStatusOnList=()=>{
		
		if ( window['updatedUserList'] )
			{
				let membersArray = window['updatedUserList'];
				let membersStatusA = [];
				let membersStatusB = [];
				let membersStatusC = [];
				let membersStatusD = [];
				let membersArraySortedByName = [];
				membersArray.sort(function(a, b){
					if(a.listStatus > b.listStatus) { return 1; }
					if(a.listStatus < b.listStatus) { return -1; }
						return 0;
				});

				for ( var i = 0; i < membersArray.length; i++ )
					{
						if (membersArray[i]['listStatus'] == 'a')
							{
								membersStatusA.push(membersArray[i]);
							}
						else if (membersArray[i]['listStatus'] == 'b')
							{
								membersStatusB.push(membersArray[i]);
							}
						else if (membersArray[i]['listStatus'] == 'c')
							{
								membersStatusC.push(membersArray[i]);
							}
						else 
							{
								membersStatusD.push(membersArray[i]);
							}							
					}
				if ( membersStatusA.length > 0 )
					{
						membersStatusA.sort(function(a, b){
							if(a.firstName > b.firstName) { return 1; }
							if(a.firstName < b.firstName) { return -1; }
								return 0;
						});
						for ( var a = 0; a<membersStatusA.length; a++ )
							{
								membersArraySortedByName.push(membersStatusA[a]);
							}
					}
				if ( membersStatusB.length > 0 )
					{
						membersStatusB.sort(function(a, b){
							if(a.firstName > b.firstName) { return 1; }
							if(a.firstName < b.firstName) { return -1; }
								return 0;
						});
						for ( var a = 0; a<membersStatusB.length; a++ )
							{
								membersArraySortedByName.push(membersStatusB[a]);
							}
					}
				if ( membersStatusC.length > 0 )
					{
						membersStatusC.sort(function(a, b){
							if(a.firstName > b.firstName) { return 1; }
							if(a.firstName < b.firstName) { return -1; }
								return 0;
						});
						for ( var a = 0; a<membersStatusC.length; a++ )
							{
								membersArraySortedByName.push(membersStatusC[a]);
							}
					}
				if ( membersStatusD.length > 0 )
					{
						membersStatusD.sort(function(a, b){
							if(a.firstName > b.firstName) { return 1; }
							if(a.firstName < b.firstName) { return -1; }
								return 0;
						});
						for ( var a = 0; a<membersStatusD.length; a++ )
							{
								membersArraySortedByName.push(membersStatusD[a]);
							}
					}
	
				this.setState({
					sessionUsers: membersArraySortedByName,
				});
			}
		
	}
	
	render() {
		return (
		<div className="part_list_holder" >
			<div className="list_color" >
				<div className="partMain" >
					<div className="closePartList" onClick={(e)=>{this.props.showParticipantList(0)}} ></div>
					{this.state.sessionUsers && this.state.sessionUsers.length > 0 ?				
						<div className="partListH1" >Members ({this.state.sessionUsers.length})</div>
						: 
						<div className="partListH1" >Members</div>
					}
					
					
					<div className="holdLabelsPartList" >
						<div className="partListLabel namePartWidth" >Name</div>
						{ /* <div className="partListLabel scorePartWidth" >Score</div> */}
						<div className="partListLabel scorePartWidth" >Camera</div>
						<div className="partListLabel scorePartWidth" >Mic</div>
						<div className="partListLabel scorePartWidth" >Status</div>
						{ /* <div className="partListLabel scorePartWidth" >Room setup</div> */}
						{ /* <div className="partListLabel scorePartWidth" >Active zone</div> */}
						<div className="partListLabel scorePartWidth" >Actions</div>
					</div>
					<div className="hold_all_members_list" id="session_members" >
					{this.state.sessionUsers && this.state.sessionUsers.length > 0 && 
						<div>
						{this.state.sessionUsers.map((opt,i)=>
							<div key={i} >
								{opt.userType === 2 && 
									<div className="oneMemberHolder" id={'participant-'+opt.id} >
										{/* i == 1 ? 
											<div className="memberNumPart"></div>
											: 
											
										*/}
										
										<div className="numPart" >{i+1}</div>
										<div className="memberInfoHold namePartWidth" > 
											{ opt.image && opt.image != '/images/host-user.png' ?
												<div className="memberImgPart" style={{backgroundImage: "url('" + opt.image + "')"}} ></div>
												:
												<div className="memberImgPart memberDefImg" ></div>
											}
											<div className="memberNamePart">{opt.firstName + ' ' + opt.lastName}</div>
										</div>
										
										
										{/*	
										<div className="memberInfoHold scorePartWidth" >
											<div className="memberScorePart" >0</div>
										</div>
										*/}
										
										
										<div className="memberInfoHold scorePartWidth" >
											<div className="memberCameraStatus" id={'listCam-'+opt.id} >{opt.cameraStatus}</div>
										</div>
										<div className="memberInfoHold scorePartWidth" >
											<div className="memberCameraStatus" id={'listMic-'+opt.id} >{opt.micStatus}</div>
										</div>
										<div className="memberInfoHold scorePartWidth" >
											{ opt.sessionStatus == 3 ?
												<div className="memberCameraStatus" id={'listStatus-'+opt.id} >Ejected</div>
												:
												<div className="memberCameraStatus" id={'listStatus-'+opt.id} >{opt.mainStatus}</div>
											}
										</div>
										
										
										{/*
										<div className="memberInfoHold scorePartWidth" >
											<div className="memberCameraStatus" >No</div>
										</div>
										*/}
										{/*
										<div className="memberInfoHold scorePartWidth" >
											<div className="memberCameraStatus" >No</div>
										</div>
										*/}
										
										
										<div className="memberInfoHold scorePartWidth" >
											{ opt.sessionStatus !== 3 &&
												<div className="memberCameraStatus ejectBtn" onClick={(e)=>{this.props.ejectParticipant(opt)}}>Eject</div>
											}
											{ opt.sessionStatus == 3 &&
												<div className="memberCameraStatus">Ejected</div>
											}
										</div>
										
										
									</div>
								}
							</div>
						)}
					</div>
					}
					</div>
				</div>
			</div>
		</div>
	)}
}
export default ParticipantsList;
